<div class="po-location-sign-up-tool">
  <h2 class="h2 split-title">
      <span class="line-1 f1 mb-0">Wanneer moet ik mijn kind</span>
      <span class="line-2 h1 t-lower">aanmelden?</span>
  </h2>
  <p class="po-location-sign-up-tool__text">Vul de geboortemaand en het geboortejaar van uw kind in om te zien wanneer u uw kind moet aanmelden.</p>
  <div class="po-location-sign-up-tool__form">
    <div class="po-location-sign-up-tool__field">
      <label class="po-location-sign-up-tool__label" for="po-signup-month">Geboortemaand</label>
      <select
        id="po-signup-month"
        [formControl]="monthControl"
        [class.po-location-sign-up-tool__input--invalid]="showMonthError()"
      >
        <option [ngValue]="null" disabled>Maand</option>
        <option *ngFor="let option of monthOptions" [ngValue]="option.value">{{ option.label }}</option>
      </select>
      <p class="po-location-sign-up-tool__error" *ngIf="showMonthError()">
        Dit is een verplicht veld.
      </p>
    </div>
    <div class="po-location-sign-up-tool__field">
      <label class="po-location-sign-up-tool__label" for="po-signup-year">Geboortejaar</label>
      <select
        id="po-signup-year"
        [formControl]="yearControl"
        [class.po-location-sign-up-tool__input--invalid]="showYearError()"
      >
        <option [ngValue]="null" disabled>Jaar</option>
        <option *ngFor="let year of yearOptions" [ngValue]="year">{{ year }}</option>
      </select>
      <p class="po-location-sign-up-tool__error" *ngIf="showYearError()">
        Dit is een verplicht veld.
      </p>
    </div>
    <div class="po-location-sign-up-tool__field">
      <span class="po-location-sign-up-tool__label po-location-sign-up-tool__label--spacer" aria-hidden="true">&nbsp;</span>
      <button
        type="button"
        (click)="search()"
        class="po-location-sign-up-tool__button button"
      >bekijken <i class="icon-right-small"></i></button>
    </div>
  </div>
  <div class="po-location-sign-up-tool__result" *ngIf="schemeItem">
    <hr class="po-location-sign-up-tool__divider" />
    <p class="po-location-sign-up-tool__result-text">{{schemeItem.description}}</p>
    <a
      [href]="schemeItem.informationUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="po-location-sign-up-tool__button button "
    >Meer informatie <i class="icon-right-small"></i></a>
  </div>
</div>
